export const ISSUES_GLOBAL = 'md_issues_GLOBAL';
export const ISSUES_FORM = 'md_issues_FORM';